module.exports = __webpack_public_path__ + "static/media/camera.1ed79a6b.png";